/**
 * Registers v-track / v-track-ignore on SSR and client.
 * Click listeners and providers live in analytics.client.ts.
 */

import type { ObjectDirective } from 'vue'
import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app'

import { vTrack, vTrackIgnore } from '../directives/analytics.directives'

const noopAnalyticsDirective: ObjectDirective<HTMLElement> = {
  getSSRProps() {
    return {}
  },
}

export default defineNuxtPlugin(nuxtApp => {
  const enabled = useRuntimeConfig().public.analytics?.enabled

  if (enabled) {
    nuxtApp.vueApp.directive('track-ignore', vTrackIgnore)
    nuxtApp.vueApp.directive('track', vTrack)
    return
  }

  nuxtApp.vueApp.directive('track-ignore', noopAnalyticsDirective)
  nuxtApp.vueApp.directive('track', noopAnalyticsDirective)
})
